import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

const BarWithSharpEdges = ({ 
  data = {}, 
  color = ["#EE1D23", "#1A2B5C"], 
  xTitle = "Date", 
  yTitle = "Count" 
}) => {
  const [chartConfig, setChartConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    if (Object.keys(data).length === 0) {
      setChartConfig({
        series: [{ name: "No Data", data: [] }],
        options: {
          chart: { height: 450, type: "bar", toolbar: { show: false } },
          colors: color,
          dataLabels: { enabled: false },
          stroke: { show: true, width: 2, colors: ["#fff"] },
          plotOptions: { bar: { horizontal: false, columnWidth: "50%", borderRadius: 6 } },
          grid: { borderColor: "#e0e6ed", strokeDashArray: 4, position: "back" },
          xaxis: {
            categories: ["No Data"], // Placeholder axis
            title: { text: xTitle, style: { fontSize: "14px", fontWeight: 600, color: "#333" } },
            labels: { style: { fontSize: "12px", color: "#666" } },
          },
          yaxis: {
            title: { text: yTitle, style: { fontSize: "14px", fontWeight: 600, color: "#333" } },
            labels: { style: { fontSize: "12px", color: "#666" } },
          },
          tooltip: { theme: "dark", y: { formatter: (val) => val } },
        },
      });
      setLoading(false);
      return;
    }

    try {
      const allDates = Object.keys(data).sort();
      const totalCompleted = allDates.map(date => data[date]?.totalCompleted || 0);
      const totalTarget = allDates.map(date => data[date]?.totalTarget || 0);

      setChartConfig({
        series: [
          { name: "Total Target", data: totalTarget },
          { name: "Total Completed", data: totalCompleted },
        ],
        options: {
          chart: { height: 450, type: "bar", toolbar: { show: false } },
          colors: color,
          dataLabels: { enabled: false },
          stroke: { show: true, width: 2, colors: ["#fff"] },
          plotOptions: { bar: { horizontal: false, columnWidth: "50%", borderRadius: 6 } },
          grid: { borderColor: "#e0e6ed", strokeDashArray: 4, position: "back" },
          xaxis: {
            categories: allDates.length > 0 ? allDates : ["No Data"], // Ensure it never breaks
            title: { text: xTitle, style: { fontSize: "14px", fontWeight: 600, color: "#333" } },
            labels: { style: { fontSize: "12px", color: "#666" } },
          },
          yaxis: {
            title: { text: yTitle, style: { fontSize: "14px", fontWeight: 600, color: "#333" } },
            labels: { style: { fontSize: "12px", color: "#666" } },
          },
          tooltip: { theme: "dark", y: { formatter: (val) => val } },
        },
      });

    } catch (error) {
      console.error("Error processing chart data:", error);
    }

    setLoading(false);
  }, [data]);

  return (
    <div className="bg-gray-100 dark:bg-gray-800 p-6 rounded-xl shadow-lg">
      <div className="rounded-xl bg-white shadow-md p-4 dark:bg-gray-900">
        {loading ? (
          <div className="text-center text-gray-500">Loading Chart...</div>
        ) : chartConfig ? (
          <ReactApexChart 
            series={chartConfig.series} 
            options={chartConfig.options} 
            type="bar" 
            height={400} 
          />
        ) : (
          <div className="text-center text-gray-500">No Data Available</div>
        )}
      </div>
    </div>
  );
};

export default BarWithSharpEdges;
